<template>
  <div :class="path == '/login' ? 'header-container row-space-center header-login-container' : 'header-container row-space-center'">
    <div class="row-space-between">
      <img
        src="@/assets/logo_white(2).png"
        style="width: 100px; cursor: pointer"
        @click="handleRouter('')"
      />
      <div class="row-center router-big">
        <div
          :class="path == '/' ? 'row-space-center position-tab-type' : 'row-center'"
        >
          <div
            :class="path == '/about/1' ? 'router-item active' : 'router-item'"
            @click="handleRouter('about/1')"
          >
            关于我们
          </div>
          <div
            :class="path == '/product' ? 'router-item active' : 'router-item'"
            @click="handleRouter('product')"
          >
            产品中心
          </div>
          <div
            :class="path == '/about/4' ? 'router-item active' : 'router-item'"
            @click="handleRouter('about/4')"
          >
            服务中心
          </div>
          <div
            :class="path == '/solution' ? 'router-item active' : 'router-item'"
            @click="handleRouter('solution')"
          >
            解决方案
          </div>
          <div
                  :class="path == '/industryNews' ? 'router-item active' : 'router-item'"
                  @click="handleRouter('industryNews')"
          >
            新闻资讯
          </div>
        </div>
        <div
          style="margin-left: 24px"
          :class="path == '/user' ? 'router-item active' : 'router-item'"
          @click="handleRouter('user')"
        >
          用户中心
        </div>
      </div>
      <div :class="dialogVisible ? 'span_m active' : 'span_m'" @click="handleActive">
        <i class="i_1"></i>
        <i class="i_2"></i>
        <i class="i_3"></i>
      </div>
    </div>

    <el-dialog
      title=""
      custom-class="dialog-panel"
      :show-close="false"
      :visible.sync="dialogVisible"
      append-to-body
      width="70%"
      @close="handleClose"
    >
      <div class="row-space-end">
        <img
          src="@/assets/close_icon1.png"
          @click="handleClose"
          style="width: 24px; cursor: pointer"
        />
      </div>
      <div>
        <div style="width: 100%" class="dialog-btn" @click="handleRouter('about/1')">关于我们</div>
        <div style="width: 100%" class="dialog-btn" @click="handleRouter('product')">产品中心</div>
        <div style="width: 100%" class="dialog-btn" @click="handleRouter('about/4')">服务中心</div>
        <div style="width: 100%" class="dialog-btn" @click="handleRouter('solution')">解决方案</div>
        <div style="width: 100%" class="dialog-btn" @click="handleRouter('industryNews')">新闻资讯</div>
        <div style="width: 100%" class="dialog-btn" @click="handleRouter('user')">用户中心</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      width: 0,

      dialogVisible: false,

      navPop: false,
      path: '',
    }
  },
    watch: {
    $route(to, from) {
      this.path = to.path
      console.log(to)
    },
    immediate: true,
    deep: true,
  },
  created() {
    this.path = this.$router.currentRoute.path
  },
  computed: {
    ...mapGetters(['getUserInfos']),
  },

  methods: {
    handleActive() {
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
    },

    handlePayment() {
      this.$router.push({
        path: '/payment',
      })
    },
    handleRouter(route) {
      this.handleClose()
      let path = this.$router.currentRoute.path
      if ('/' + route == path) {
        return
      }
      if ((!this.getUserInfos || !this.getUserInfos.userName) && route == 'user') {
        route = 'login'
      }
      this.path = '/' + route

      this.$router
        .push({
          path: '/' + route,
        })
        .catch((error) => {
          console.log(error)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.module.scss';
@import '@/styles/mixin.scss';
@import '@/styles/font.scss';
.header-container {
  width: 100vw;
  position: relative;
  height: 60px;
  padding: 0 24px 0 48px;
  box-sizing: border-box;
  // background:rgb(114,114,114);
  background: rgba(0, 1, 6, 1);
  position:relative;
}

.header-login-container{
  background: rgba(0, 1, 6, .6);
}

.router-item {
  color: #fff;
  font-size: 16px;
  margin-right: 24px;
  cursor: pointer;
}

.router-item:last-child {
  margin-right: 0px;
}

.position-tab-type .router-item{
  margin-right: 36px;
}

.active {
  font-weight: 600;
}

.span_m {
  display: none;
}

.position-tab-type{
  position:absolute;
  top:0;
  bottom:0;
  right:15vw;
  left:15vw;
}

// 弹窗
:deep(.el-dialog) {
  padding: 12px;
  background: #fff;
  border-radius: 5px;
}

:deep(.el-dialog__wrapper) {
  background: #fff;
}

:deep(.el-dialog__header) {
  display: none;
}

:deep(.el-dialog__footer) {
  display: none;
}

:deep(.el-dialog__body) {
  padding: 0px;
}

.dialog-btn {
  padding: 20px 0;
  box-sizing: border-box;
  width: 100%;
  font-size: 16px;
  border-bottom: 1px solid rgb(242, 242, 242);
}

.dialog-btn:first-child {
  padding: 0px 0px 20px 0;
}

.dialog-btn:last-child {
  border-bottom: none;
}

@media screen and (max-width: 1400px) {
}

@media screen and (max-width: 1200px) {
}

@media screen and (max-width: 930px) {
  .router-item {
    font-size: 14px;
  }
}

@media screen and (max-width: 768px) {
  .router-big {
    display: none;
  }
  .router-item {
    font-size: 12px;
  }
  .span_m {
    width: 30px;
    height: 20px;
    display: inline-block;
    cursor: pointer;
  }

  .span_m i {
    display: block;
    height: 3px;
    width: 24px;
    margin-bottom: 5px;
    transition: all 0.4s;
    transform-origin: right;
    background: #fff;
  }

  .span_m.active .i_1 {
    transform: rotate(-45deg);
    width: 96%;
    margin-bottom: 10px;
  }
  .span_m.active .i_2 {
    opacity: 0;
  }
  .span_m.active .i_3 {
    transform: rotate(45deg);
    width: 96%;
    margin-bottom: 11px;
  }
}
</style>
